import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { BRAND, CONTACT } from "../lib/landingData";
import { LogoMark } from "../components/landing/LogoMark";

export const LegalLayout = ({ title, updated, children, testId }) => {
  const { t } = useLang();
  const c = t.legalCommon;
  return (
    <div className="grain no-x-overflow relative min-h-screen bg-[var(--page)] text-[var(--ink)]" data-testid={testId}>
      <div className="border-b border-[var(--hairline)] bg-[var(--page)]/80 backdrop-blur-md sticky top-0 z-40">
        <div className="mx-auto max-w-[900px] px-5 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5">
            <LogoMark className="h-9 w-auto shrink-0" testId="legal-logo-mark" />
            <span className="font-display text-base sm:text-xl leading-none tracking-tight">{BRAND.name}</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[var(--muted-ink)] hover:text-[var(--ink)] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> {c.back}
          </Link>
        </div>
      </div>

      <main className="mx-auto max-w-[900px] px-5 sm:px-8 py-16 sm:py-24">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[var(--ink)]" />
            <span className="text-[11px] uppercase tracking-[0.25em] text-[var(--muted-ink)] font-semibold">{c.legal}</span>
          </div>
          <h1 className="font-display font-semibold tracking-tight leading-[1.05] text-4xl sm:text-5xl">{title}</h1>
          <p className="mt-4 text-sm text-[var(--muted-ink)]">{updated}</p>
        </motion.div>

        <div className="mt-12 space-y-10 legal-body">{children}</div>
      </main>
    </div>
  );
};

export const Clause = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl sm:text-2xl leading-tight mb-3">{heading}</h2>
    <div className="space-y-3 text-base text-[var(--muted-ink)] leading-relaxed">{children}</div>
  </section>
);

export const ContactClause = ({ heading, lead }) => (
  <section>
    <h2 className="font-display text-xl sm:text-2xl leading-tight mb-3">{heading}</h2>
    <p className="text-base text-[var(--muted-ink)] leading-relaxed">{lead}</p>
    <p className="mt-2 text-base leading-relaxed">
      <span className="text-[var(--ink)]">{BRAND.legalEntity}</span>
    </p>
    <p className="mt-2 text-base leading-relaxed">
      <a href={CONTACT.emailHref} data-testid="legal-contact-email" className="underline underline-offset-2 text-[var(--ink)]">{CONTACT.email}</a>
      <span className="text-[var(--muted-ink)]"> · </span>
      <a href={CONTACT.phoneHref} data-testid="legal-contact-phone" className="underline underline-offset-2 text-[var(--ink)]">{CONTACT.phone}</a>
    </p>
    <p className="mt-2 text-base leading-relaxed text-[var(--muted-ink)]" data-testid="legal-contact-address">{CONTACT.address}</p>
  </section>
);
